module.exports = __webpack_public_path__ + "static/map-6eec7c6d3504210e217d8b10de3efa85.jpg";